export const fetchStatusDisplayUtils = (type) => {
    switch (type) {
        case 0:
            return {
                icon: <i className='fas fa-exclamation-triangle text-danger mr-2'></i>,
                color: "danger"
            }
        case 1:
            return {
                icon: <i className='fas fa-exclamation-triangle text-warning mr-2'></i>,
                color: "warning"
            }
        case 2:
            return {
                icon: <i className='fas fa-info-circle text-center mr-2'></i>,
                color: "info"
            }
        case 3:
            return {
                icon: <i className='fas fa-check-circle text-success text-center mr-2'></i>,
                color: "success"
            }
        default:
            return null
    }
}